import { ui } from "@/components/ui";
import InjectionForm from "@/features/injection/components/InjectionForm";
import { services as s } from "@/services";
import { ArrowRight } from "lucide-react";
import React from "react";
import Subtitle from "../../../components/common/Subtitle";
import SurgeryForm from "../features/surgeries/components/SurgeryForm";

const FormTypes = {
	SURGERY: "SURGERY",
	INJECTION: "INJECTION",
};

interface Props {
	diaryId: string;
	organisationId: string;
	eventId: string;
	trackerId?: string;
	initialForm?: keyof typeof FormTypes;
	// Add any additional props here if needed
}

const SelectEventForm: React.FC<Props> = (props) => {
	const [currentForm, setCurrentForm] = React.useState<Props["initialForm"]>(
		props.initialForm,
	);

	React.useEffect(() => {
		setCurrentForm(props.initialForm);
	}, [props.initialForm]);

	switch (currentForm) {
		case FormTypes.SURGERY:
			return (
				<SurgeryForm
					diaryId={props.diaryId}
					eventId={props.eventId}
					surgeryId={s.uuidv4()}
				/>
			);
		case FormTypes.INJECTION:
			return (
				<InjectionForm
					diaryId={props.diaryId}
					eventId={props.eventId}
					injectionId={s.uuidv4()}
					organisationId={props.organisationId}
				/>
			);
		default:
			return (
				<div className="flex flex-col gap-4 p-4">
					<Subtitle words="Select Intervention" />
					{[
						{ label: "Surgery", value: FormTypes.SURGERY },
						{ label: "Injection", value: FormTypes.INJECTION },
					].map((option) => (
						<ui.Button
							key={option.label}
							className="flex flex-row justify-between items-center w-full"
							size="md"
							variant="outline"
							type="button"
							onClick={() =>
								setCurrentForm(
									option.value as keyof typeof FormTypes,
								)}
						>
							<span>{option.label}</span>
							<ArrowRight />
						</ui.Button>
					))}
				</div>
			);
	}
};

export default SelectEventForm;
